module.exports = __webpack_public_path__ + "thaisansneue-regular-webfont.89c8a0d070800453cbf0.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/css/fonts/thaisansneue-regular-webfont.woff2
// module id = ../../../../../src/assets/corporate/css/fonts/thaisansneue-regular-webfont.woff2
// module chunks = styles